import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderService } from '@services';

@Component({
  selector: 'unicon-unarchive-alert',
  templateUrl: './unarchive-alert.component.html',
  styleUrl: './unarchive-alert.component.scss',
})
export class UnarchiveAlertComponent {
  @Input() isVisible: boolean = false;
  @Input() position: 'top' | 'bottom' = 'top';
  @Input() orderId!: string;
  @Input() closeModal!: () => void;
  @Output() onNextLead: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeModalChat: EventEmitter<string> = new EventEmitter<string>();

  protected isLoading: boolean = false;

  constructor(private orderService: OrderService) {}

  protected unArchiveChatLead() {
    this.isLoading = true;
    this.orderService.unArchiveLead(this.orderId).subscribe({
      next: () => {
        this.isLoading = false;
        if (this.closeModalChat) {
          this.closeModalChat.emit();
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }
}
